
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { User } from '@/types';

interface GlobalState {
  // 用户状态
  user: User | null;
  isAuthenticated: boolean;
  
  // 主题和布局
  sidebarCollapsed: boolean;
  darkMode: boolean;
  
  // 全局加载状态
  isLoading: boolean;
  
  // Actions
  setUser: (user: User | null) => void;
  setAuthenticated: (status: boolean) => void;
  toggleSidebar: () => void;
  toggleDarkMode: () => void;
  setLoading: (loading: boolean) => void;
}

export const useGlobalStore = create<GlobalState>()(
  devtools(
    persist(
      (set) => ({
        user: null,
        isAuthenticated: false,
        sidebarCollapsed: false,
        darkMode: false,
        isLoading: false,

        setUser: (user) => set({ user }),
        setAuthenticated: (status) => set({ isAuthenticated: status }),
        toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
        toggleDarkMode: () => set((state) => ({ darkMode: !state.darkMode })),
        setLoading: (loading) => set({ isLoading: loading }),
      }),
      {
        name: 'global-storage',
        partialize: (state) => ({ 
          darkMode: state.darkMode,
          sidebarCollapsed: state.sidebarCollapsed 
        }),
      }
    ),
    { name: 'global-store' }
  )
);
